import React, {useEffect, useState} from 'react'
import { CardBody, Icons, Table } from '@fabricks/ui-components'
import { useKeycloak } from 'react-keycloak'
import { get as _get, set as _set } from 'lodash'
import { FbTableColumn, FbTablePagination, FbTableRow } from '@fabricks/ui-components/dist/components/Table/Table'
import { Skeleton } from '@material-ui/lab'
import {BoxTypeResourceList, FilterParam, PackageTypeDto} from '../../api/models'
import { usePackagetypes } from "../../services/dataService";
import Swal from "sweetalert2";
import Navigation from "../../constants/navigation";

interface PackagetypesTableProps {
    initLoadingTime?: number
    searchTerm?: string
    filter?: FilterParam[],
    jumpToPage?: number
}

export const PackagetypesTable: React.FC<PackagetypesTableProps> = (props: PackagetypesTableProps) => {
    const { initLoadingTime, filter, searchTerm, jumpToPage } = props
    const [initLoading, setInitLoading] = useState((initLoadingTime || 0) > 0)
    const [page, setPage] = useState(0)
    const [sort, setSort] = useState({})
    const [pageSize, setPageSize] = useState(25)
    const [keycloak] = useKeycloak()
    const { data, error, loading } = usePackagetypes(keycloak.token, {
        pagination: { page, size: pageSize },
        sort: Object.keys(sort)
            .map(key => {
                return _get(sort, key, null)
            })
            .filter(e => e != null && e.order !== undefined),
        q: searchTerm || null,
        filter: filter || []
    })

    useEffect(() => {
       if(jumpToPage != null){
            setPage(jumpToPage)
        }
    }, [jumpToPage])

    const onSort = (id: string, direction: string | undefined) => {
        let newDirection: string | undefined
        switch (direction) {
            case 'ASC':
                newDirection = 'DESC'
                break
            case 'DESC':
                newDirection = undefined
                break
            default:
                newDirection = 'ASC'
                break
        }

        const temp = { ...sort }
        _set(temp, id, { field: id, order: newDirection })
        setSort(temp)
    }

    const columns: FbTableColumn[] = [
        { id: 'name', label: 'Name' },
        { id: 'width', label: 'Width', renderValue: (size: string) => `${parseFloat(size).toFixed(2)} mm` },
        { id: 'height', label: 'Height', renderValue: (size: string) => `${parseFloat(size).toFixed(2)} mm` },
        { id: 'depth', label: 'Depth', renderValue: (size: string) => `${parseFloat(size).toFixed(2)} mm` },
        { id: 'volume', label: 'Volume', renderValue: (size: string) => (<span> {(parseFloat(size) / 1000).toFixed(2)} cm <sup>3</sup> </span>)},
        {
            id: 'isValid', label: 'Integrity', renderValue: (isValid: String) => {
                if (isValid === 'true') {
                    return (<div className="indicator_check" style={{ color: 'rgb(144, 238, 2)', cursor: 'pointer' }}><Icons.Check /></div>)
                }
                return (<div className="indicator_error" style={{ color: '#d32f2f', cursor: 'pointer' }}><Icons.Error /></div>)
            }
        },
    ]
    const pagination: FbTablePagination = {
        rowsPerPage: _get(data, 'getPackageTypes.meta.size', pageSize),
        currentPage: _get(data, 'getPackageTypes.meta.offset', page),
        count: _get(data, 'getPackageTypes.meta.count', 0),
        onChangeRowsPerPage: event => setPageSize(parseInt(event.target.value, 10)),
        onChangePage: (event, newPage) => setPage(newPage),
    }
    const rows: FbTableRow[] = _get(data, 'getPackageTypes.data', []).map((packageType: PackageTypeDto) => {
        return {
            uuid: packageType.uuid,
            name: packageType.name,
            width: packageType.width,
            height: packageType.height,
            depth: packageType.depth,
            volume: packageType.volume,
            isValid: packageType.isValid ? "true" : "false"
        }
    })

    if (initLoading || loading) {
        setTimeout(() => setInitLoading(false), initLoadingTime)
        return (
            <>
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
                <Skeleton variant="rect" animation="wave" width="100%" height={30} style={{ marginBottom: '5px' }} />
            </>
        )
    }

    if (_get(data, 'getPackageTypes.error', null) != null) {
        return (
            <div>
                {_get(data, 'getPackageTypes.error.message', '')}
                {_get(data, 'getPackageTypes.error.code', '')}
            </div>
        )
    }

    if (error) {
        console.error(error)
        return <div>An unknown error has occured</div>
    }

    return (
        <Table
            columns={columns}
            pagination={pagination}
            rows={rows}
            onRowClick={(uuid: string) => console.log(`Clicked row with uuid ${uuid}`)}
        />
    )
}

export default PackagetypesTable
